import { render, staticRenderFns } from "./WholeSearch.vue?vue&type=template&id=caa70340&scoped=true&"
import script from "./WholeSearch.vue?vue&type=script&lang=js&"
export * from "./WholeSearch.vue?vue&type=script&lang=js&"
import style0 from "./WholeSearch.vue?vue&type=style&index=0&id=caa70340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa70340",
  null
  
)

export default component.exports